import React from "react";
import { Link } from "react-router-dom";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            Kovid India provides integrated electronic solutions supporting Defence, Government, R&D, and manufacturing environments. Our capabilities span test & measurement, system integration, RF solutions, battery testing, and controlled workplace infrastructure.
          </p>
          <p>All solutions are configured in alignment with customer-defined technical specifications and operational requirements.</p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => {
              const slug = d.name
                .toLowerCase()
                .replace(/\s+/g, "-");

              return (
                <div key={`${d.name}-${i}`} className="col-md-6 col-lg-6">
                  <Link
                    to={`/service/${slug}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div className="service-card h-100">

                      <div className="service-img-wrapper">
                        <img
                          src={d.img}
                          alt={d.name}
                          className="service-img"
                        />
                      </div>

                      <div className="service-content">
                        <h5>{d.name}</h5>
                        <p>{d.text}</p>
                      </div>

                    </div>
                  </Link>
                </div>
              );
            })
            : "loading"}
        </div>
      </div>
    </div>
  );
};

